<template>
  <el-card header="修改密码" class="box-card">
    <el-form :model="formData" :rules="rules" ref="formData" label-width="80px">
      <el-form-item label="旧 密 码" prop="oldPassword">
        <el-input type="password" size="small" v-model="formData.oldPassword"></el-input>
      </el-form-item>
      <el-form-item label="新 密 码" prop="newPassword">
        <el-input type="password" size="small" v-model="formData.newPassword"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input type="password" size="small" v-model="formData.confirmPassword"></el-input>
      </el-form-item>
      <el-form-item label=" ">
        <el-button type="primary" @click="submitForm('formData')">提交</el-button>
        <el-button @click="resetForm('formData')">重置</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      rules: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.formData.newPassword) {
                callback(new Error("两次输入密码不一致!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      var that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          that.api.staff
            .password(Object.assign({}, that.formData))
            .then(function(response) {
              if (!response.data.errorCode) {
                that.$refs[formName].resetFields();
                that.$message({
                  message: "密码修改成功！",
                  type: "success",
                  duration: 2000,
                  onClose: function() {}
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style scoped>
.el-form-item {
  margin-bottom: 18px;
}
</style>



// WEBPACK FOOTER //
// password.vue?0dc8e024